import React from 'react';
import { BasicTaskList } from '../../styles/BasicTaskList';
import { useBasicDetails } from '../../../store';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Task } from '../../../taskList/interfaces';
import StageSection from '../StageSection';
import { CandidateMessages } from '../../../common/utils/getCandidateMessages';
import { useTranslation } from 'react-i18next';
import { expectedTimeToComplete, stageListMapper } from '../../utils/basicStageList';
import CkEditorContent from '../../../common/components/CkEditorContent';
import { useEndWorkflow } from './../../../taskList/hooks/useEndWorkflow';

interface BasicTaskListLayoutProps {
  data: Task[];
  candidateMessages: CandidateMessages;
  deadlineDate: string | undefined;
}

const BasicTaskListLayout = (props: BasicTaskListLayoutProps): JSX.Element => {
  const { data, candidateMessages, deadlineDate } = props;
  const {
    template: { settings },
  } = useBasicDetails();
  const { t } = useTranslation();
  const classes = BasicTaskList(settings);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  useEndWorkflow(stageListMapper(data));

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={10} lg={10} className={classes.grid}>
        <Paper elevation={1} className={classes.paper}>
          <Grid container justify={!smUp ? 'center' : 'flex-start'} className={classes.taskListHeader}>
            <Grid item lg={7} className={classes.headerGrid}>
              <Typography variant="h1">{candidateMessages.taskListPageHeading}</Typography>
              <Box marginTop={smUp ? 0.5 : 0.6}>
                <CkEditorContent
                  content={candidateMessages.taskListPageContent}
                  pageStartTime={new Date()}
                  generalContentName={'BASICTASKLIST_PAGE'}
                />
              </Box>
            </Grid>
            <Grid container justify={smUp ? 'center' : 'flex-end'} item lg={5} className={classes.headerGrid}>
              <Typography variant="caption" className={`${classes.typographyCation} ${classes.marginBottom20}`}>
                <strong>{t('candidateDeadline')}</strong> {deadlineDate}
              </Typography>
              <Box marginTop={smUp ? 0.5 : 0.6} className={classes.typographyCation}>
                <Typography variant="caption" className={classes.typographyCation}>
                  <strong>{t('candidateExpectedTimeToComplete')}</strong> {expectedTimeToComplete(data)}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <StageSection data={data} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default BasicTaskListLayout;
